import { WmButton } from "@watermarkinsights/ripple-react";
import { InstitutionIcon } from "@/features/common/Icons";
import { Organization } from "./ContributorInsights";
import { useReducer } from "react";
import { useIntl } from "react-intl";
import translate from "@/i18n/translate";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "@/features/common/helper";

interface ContributorInstitutionInsightsProps {
  institution: Organization[];
}
interface State {
  showInstitution: boolean;
}
interface Action {
  type: string;
  showInstitution: boolean;
}
const defaultAction: Action = {
  type: "",
  showInstitution: false
};

const stateReducer = (state: State, action: Action) => {
  switch (action.type) {
    case "toggleInstitution":
      return {
        ...state,
        showInstitution: !state.showInstitution
      };
    default:
      return state;
  }
};

const initialState: State = {
  showInstitution: true
};

export function ContributorInstitutionInsights({
  institution
}: ContributorInstitutionInsightsProps) {
  const [state, dispatch] = useReducer(stateReducer, initialState);
  const toggleInstitution = () => {
    dispatch({ ...defaultAction, type: "toggleInstitution" });
  };
  const toggleInstitutionLabel = useIntl().formatMessage({
    id: "app.home.toggleInstitution"
  });
  return (
    <div className="my-institution-container">
      <div className="flex-row -verticallycentered">
        <button
          className={
            state.showInstitution
              ? "expand-button mdi  mdi-menu-down"
              : "expand-button mdi  mdi-menu-right"
          }
          onClick={toggleInstitution}
          aria-label={toggleInstitutionLabel}
        ></button>
        <span className="my-institution">
          {translate("app.home.myInstitution")}
        </span>
      </div>
      {state.showInstitution && (
        <InstitutionCard institutionData={institution[0]} />
      )}
    </div>
  );
}
interface InstitutionCardProps {
  institutionData: Organization;
}
const InstitutionCard = ({ institutionData }: InstitutionCardProps) => {

  const navigate = useNavigate();
  const queryString = window.location.search;
  let institutionInsightsUrl = queryString.includes("locale")
    ? `/insights/institution/${institutionData?.institutionUuid}/${queryString}`
    : `/insights/institution/${institutionData?.institutionUuid}`;
  function navigateToUrl(url: string) {
    scrollToTop(".home-page-header");
    navigate(url);
  }
  return (
    <div className="institution-name">
      <InstitutionIcon />
      <div className="">
        <WmButton
          buttonType="textonly"
          onClick={() => navigateToUrl(institutionInsightsUrl)}
        >
          <div className="instiution-link">{institutionData?.name}</div>
        </WmButton>
      </div>
    </div>
  );
};
